import styled from 'styled-components'
import { css } from '@styled-system/css'

import Text from './Text'

const Display = styled(Text)(
  css({
    fontFamily: 'Proxima-Nova',
    fontWeight: 600,
    fontSize: ['38px', '42px', '48px'],
    letterSpacing: ['-1.14px;','-1.26px','-1.44px'],
    lineHeight: ['48px','50px','56px'],
    textTransform: 'uppercase'
  })
)

Display.defaultProps = {
  as: 'h1'
}

export default Display
